(function() {
  var $filtersResults = document.querySelector('.js-filters-results');
  if ($filtersResults) {
    var $body = document.querySelector('body');
    var $filters = document.querySelector('.js-filters');
    var $openBtn = document.querySelector('.js-filters-open');
    var $closeBtn = document.querySelectorAll('.js-filters-close');

    $openBtn.addEventListener('click', function() {
      $body.classList.add('is-overlaid-mobile');
      $filters.classList.add('is-opened');
    });

    Array.from($closeBtn).forEach(function(item) {
      item.addEventListener('click', function() {
        $body.classList.remove('is-overlaid-mobile');
        $filters.classList.remove('is-opened');
      });
    });
  }
})();
